import { TrophyIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import {
  agenticScoreBadgeClassNames,
  agenticScoreIconClassNames,
  candidacySourceToLabel,
  candidacySourceToOrigin,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { CandidacySource } from "@/types";

// Gold chip marking a candidacy that came from an internal source (our own
// network / product) rather than a paid platform. Renders nothing otherwise.
// isIconOnly collapses it to just the trophy (label in a tooltip) for dense
// spots like kanban cards.
export const InternalSourceBadge = ({
  isIconOnly = false,
  source,
}: {
  isIconOnly?: boolean;
  source: CandidacySource | null;
}) => {
  if (!source || candidacySourceToOrigin[source] !== "internal") return null;

  /* Render */
  const render = () => {
    if (!isIconOnly) {
      return (
        <Badge
          className={cn(
            "shrink-0 border-amber-300 bg-amber-100 font-semibold text-amber-800",
            agenticScoreBadgeClassNames.xs,
          )}
        >
          <TrophyIcon className={agenticScoreIconClassNames.xs} />
          {candidacySourceToLabel[source]}
        </Badge>
      );
    }

    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Badge className="h-4 w-4 shrink-0 justify-center rounded-full border-amber-300 bg-amber-100 p-0 text-amber-800">
                <TrophyIcon className="h-2.5 w-2.5 shrink-0" />
              </Badge>
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            {candidacySourceToLabel[source]}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  };

  return render();
};
